// src/environments/production.ts
import environment from './base';

const baseApi = '/school-management'
const env = environment(baseApi);
const data = {
  ...env,
  isMock: false,
  idleTimeout: 60,
  extendLogout: 0
}

export default data;